import {ChangeDetectorRef, Component, ElementRef, Renderer2} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {DynamicFormService} from '../../../dynamic-form/dynamic-form.service';
import {BaseFieldComponent} from '../../base/base-field/base-field.component';
import {EventDispatcherService} from '../../../events/event-dispatcher.service';
import {CustomFieldConfig} from '../custom-field.config';
import {CustomFieldService} from '../custom-field.service';

@Component({
    selector: 'mydocma-form-custom-field',
    templateUrl: './custom-field.component.html',
    styleUrls: ['./custom-field.component.scss'],
    providers: [AsyncPipe]
})
export class CustomFieldComponent extends BaseFieldComponent<CustomFieldConfig> {

    public readonly staticCssClass = 'mydocma-custom-field';

    constructor(
        public readonly dynamicFormService: DynamicFormService,
        public readonly changeDetectorRef: ChangeDetectorRef,
        public readonly eventDispatcher: EventDispatcherService,
        public readonly customFieldService: CustomFieldService,
        element: ElementRef,
        renderer: Renderer2
    ) {
        super(dynamicFormService, changeDetectorRef, eventDispatcher,element,renderer);
    }
}
